import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Col, Form, Input, message, Row, Table } from 'antd';
import { connect } from 'react-redux';
import { setBackInfo } from '@store/modules/back_info';
import { queryAbleReceipt, queryImportReceipt, queryReceiptList } from '@api/finance/receipt';
import ModalImport from './ModalImport';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      total: 0,
      pageNo: 1,
      permission: false,
    };
  }

  componentDidMount() {
    this.judge(this.props.account_info, () => {
      this.loadData(1);
    });
  }

  componentWillUnmount() {
    const { pageNo, condition } = this.state;
    const params = {
      pageNo,
      condition,
    };
    this.props.dispatch(setBackInfo(params));
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.account_info !== nextProps.account_info) {
      this.judge(nextProps.account_info);
    }
  }

  // 加载需公司回单卡信息数据
  loadData = pageNo => {
    const params = {};
    const { condition, permission } = this.state;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    params.condition = condition || '';
    if (!permission.all && !permission.all) {
      params.status = 1;
    }
    this.setState({
      pageNo: current,
      isLoading: true,
    });
    queryReceiptList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
          total: res.totalSize,
          isLoading: false,
        });
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { pageNo } = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState(
          {
            condition: values.condition,
          },
          () => {
            this.loadData(pageNo);
          },
        );
      }
    });
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { condition } = this.state;
    return (
      <div>
        <Form layout="inline" onSubmit={this.handleSubmit} style={{ textAlign: 'right' }}>
          <FormItem>
            {getFieldDecorator('condition', {
              initialValue: condition || null,
            })(<Input placeholder="请输入关键字" />)}
          </FormItem>
          <FormItem>
            <Button htmlType="submit">查询</Button>
          </FormItem>
        </Form>
      </div>
    );
  };

  judge = (accountInfo, callback = () => {}) => {
    const role = accountInfo.roles;
    const permission = {};
    role.forEach((sign, index) => {
      if (sign === '[CWManager]' || sign === '[Caissier]') {
        permission.view = true;
      }
      if (sign === '[CWManager]') {
        permission.add = true;
      }
    });
    if (accountInfo.admin) {
      permission.all = true;
    }

    this.setState(
      {
        permission,
      },
      callback,
    );
  };

  columns = () => {
    return [
      {
        title: '序号',
        dataIndex: 'unid',
      },
      {
        title: '开户行',
        dataIndex: 'bankName',
      },
      {
        title: '公司名称',
        dataIndex: 'compName',
      },
      {
        title: '帐号',
        dataIndex: 'bankBook',
      },
      {
        title: '备注',
        dataIndex: 'remark',
      },
      {
        title: '操作',
        render: (text, record) => {
          const { permission } = this.state;
          return (
            <span>
              {permission.all || permission.view ? (
                <Link to={`/finance/receipt/open/${record.uuid}`}>查看</Link>
              ) : null}
              {permission.all || permission.add ? <span className="ant-divider" /> : null}
              {permission.all || permission.add ? (
                <Link to={`/finance/receipt/edit/${record.uuid}`}>编辑</Link>
              ) : null}
              {permission.all || permission.add ? <span className="ant-divider" /> : null}
              {permission.all || permission.add ? (
                <a
                  href="#"
                  onClick={() => {
                    queryAbleReceipt({
                      uuid: record.uuid,
                      status: record.status === 2 ? 1 : 2,
                    }).then(({ statusCode }) => {
                      if (statusCode === 200) {
                        message.success(`${record.status === 2 ? '启用' : '禁用'}成功`);
                        this.loadData();
                      }
                    });
                  }}
                >
                  {record.status === 2 ? '启用' : '禁用'}
                </a>
              ) : null}
            </span>
          );
        },
      },
    ];
  };

  handleModalVisible = visible => {
    this.setState({ visible });
  };

  handleImport = params => {
    queryImportReceipt(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.loadData(1);
        this.handleModalVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { data, isLoading, total, pageNo, permission, visible } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <div>
        <div className="tableList">
          <Row style={{ paddingBottom: '20px' }}>
            <Col span={13}>
              {permission.all || permission.add ? (
                <span>
                  <Link to="/finance/bookInfo/add">
                    <Button type="primary">添加</Button>
                  </Link>
                  <Button style={{ marginLeft: '10px' }} onClick={this.handleModalVisible}>
                    导入
                  </Button>
                </span>
              ) : null}
            </Col>

            <Col span={11}>
              <div className="tableListForm">{this.renderSearchForm()}</div>
            </Col>
          </Row>
        </div>
        <Table
          rowKey="uuid"
          loading={isLoading}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
        {visible ? (
          <ModalImport cancel={this.handleModalVisible} handleSubmit={this.handleImport} />
        ) : null}
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
  account_info: state.account_info,
}))(Form.create({ wrappedComponentRef: true })(Index));



// WEBPACK FOOTER //
// ./src/components/finance/receipt/Index.js